import { useState } from "react";
const AgeCalculation = (props) => {
  const today = new Date();
  const birth = new Date(props.birthDate);
  console.log(birth);
  //   console.log(props.birthDate);
  //   console.log(props.birthDate + `10:45:31.123Z`);
  let deAge = today.getFullYear() - birth.getFullYear();
  const monthDifference = today.getMonth() - birth.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birth.getDate())
  ) {
    deAge--;
  }
  const [age, setAge] = useState(deAge);

  // Adjust the age if the current date is before the birthday this year

  console.log(age);
  return <>{deAge * 1 <= 0 ? "Less than 12 month" : deAge}</>;
};
export default AgeCalculation;
